import { render, staticRenderFns } from "./ReviewTable.vue?vue&type=template&id=5933c7ac"
import script from "./ReviewTable.vue?vue&type=script&lang=js"
export * from "./ReviewTable.vue?vue&type=script&lang=js"
import style0 from "./ReviewTable.vue?vue&type=style&index=0&id=5933c7ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports